<template>
  <div class="variety-card">
    <article :class="{ 'variety-is-promoted': isVarietyPromoted }">
      <template v-if="variety.mainImageUrls">
      <a v-if="variety.url"
         :href="variety.url"
      >
        <product-image
          :resolutions="variety.mainImageUrls"
          :is-new="variety.new"
          :language="language"
          :sizes="sizes"
          :alt="variety.variety"
        ></product-image>
      </a>
      <product-image
        v-else
        :resolutions="variety.mainImageUrls"
        :is-new="variety.new"
        :language="language"
        :sizes="sizes"
      ></product-image>
      </template>

      <div v-if="isVarietyPromoted" v-text="variety.promotionText" class="variety-promotion-text"></div>
      <h1 v-text="variety.variety"></h1>
      <p v-for="slogan in variety.slogan" v-text="slogan" :key="slogan"></p>
      <p v-if="showSubheadline" v-text="variety.subHeadline"></p>
      <!-- <h2 v-if="variety.mainCharacteristics && variety.mainCharacteristics.length"
          v-text="translate('lblResultListItemMainCharacteristicsHeadline')"
      ></h2> //-->
      <ul v-if="variety.mainCharacteristics && variety.mainCharacteristics.length" class="kws-int-variety__list">
        <li v-for="extra in variety.mainCharacteristics" :key="extra"><i class="s s-check"></i><span v-text="extra"></span></li>
      </ul>
      <footer>
        <div class="variety-buttons">
          <a
            v-if="variety.url"
            :href="variety.url"
            v-text="translate('btnResultListItemMore')"
            class="link-more"
          ></a>
          <checkbox
            v-if="activateComparison"
            :id="id"
            :label="comparisonSelectionLabel"
            :checked="variety.toBeCompared"
            :disabled="disabled"
            @change="toggleComparison"
            @click="handleClick"
          ></checkbox>
        </div>

        <div v-if="isAnyCtaButtonActive" class="variety-cta-buttons">
          <a
            v-if="showBookingLink"
            :href="bookingLink"
            v-text="translate('btnBookingToolLink')"
            class="button button--medium button--primary"
          ></a>
          <a
            v-if="showSalesforceFormLink"
            :href="salesForceFormLinkUrl"
            v-text="translate('btnSalesforceLink')"
            class="button button--medium button--primary"
          ></a>
          <a
            v-if="variety.shopUrl"
            :href="variety.shopUrl"
            class="button button--medium button--primary"
          >
            <cart-icon></cart-icon>
            {{ translate('btnShopLink') }}
          </a>
        </div>
      </footer>
    </article>
  </div>
</template>

<script>
import { slugify } from '../../shared/Utils';
import Checkbox from '../../shared/components/checkbox.vue';
import ProductImage from './product-image.vue';
import CartIcon from './icons/cart-icon.vue';

export default {
  name: 'ResultViewItem',
  data: () => ({
    resolutions: [],
  }),
  props: {
    activateComparison: Boolean,
    activateBookingLink: Boolean,
    activateSalesforceFormLink: Boolean,
    activateSubheadline: Boolean,
    tooMuchVarietiesSelected: Boolean,
    bookingLink: String,
    salesforceFormLink: String,
    comparisonSelectionLabel: String,
    language: {
      type: String,
      required: true,
    },
    variety: {
      type: Object,
      required: true,
    },
    crop: {
      type: String,
      required: true,
    },
  },
  computed: {
    id() {
      return slugify(`compare-${this.variety.id}`);
    },
    sizes() {
      const paddings = {
        s: {
          outer: 27,
          inner: 12,
        },
        m: {
          w: 768,
          max: '100vw',
          outer: 78,
          inner: 9,
        },
        l: {
          w: 1024,
          max: '100vw',
          outer: 116,
          inner: 12,
        },
        xl: {
          w: 1280,
          max: '79.25rem',
          outer: 116,
          inner: 15,
        },
      };
      const sizes = [];
      sizes.unshift(`calc(100vw - ${(2 * (paddings.s.outer + paddings.s.inner)) / 16}rem)`);
      ['m', 'l', 'xl'].forEach((breakpoint) => {
        sizes.unshift(`(min-width: ${paddings[breakpoint].w}px) calc(((${paddings[breakpoint].max} - ${(2 * paddings[breakpoint].outer) / 16}rem) / 3) - ${(2 * paddings[breakpoint].inner) / 16}rem)`);
      });
      return sizes.join(',');
    },
    disabled() {
      return this.tooMuchVarietiesSelected && !this.variety.toBeCompared;
    },
    showBookingLink() {
      return this.activateBookingLink && this.bookingLink;
    },
    showSalesforceFormLink() {
      return this.activateSalesforceFormLink && this.salesforceFormLink;
    },
    showSubheadline() {
      return this.activateSubheadline && this.variety.subHeadline;
    },
    salesForceFormLinkUrl() {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set('variety-name', this.variety.variety);
      urlSearchParams.set('crop', this.crop);
      return `${this.salesforceFormLink}?${urlSearchParams.toString()}`;
    },
    isAnyCtaButtonActive() {
      return this.showBookingLink || this.showSalesforceFormLink || this.variety.shopUrl;
    },
    isVarietyPromoted() {
      return this.variety.promoted && this.variety.promotionText;
    },
  },
  methods: {
    toggleComparison(add) {
      this.$emit('toggle-comparison', { id: this.variety.id, add });
    },
    handleClick(disabled) {
      if (disabled) {
        document.dispatchEvent(new CustomEvent('too-many-varieties-to-compare', {
          bubbles: true,
          cancelable: true,
        }));
      }
    },
  },
  components: {
    CartIcon,
    ProductImage,
    Checkbox,
  },
};
</script>

<style lang="scss">
.variety-card article {
  background-color: $color-kws-black-5;

  .bg-white & {
    background-color: $color-white;
  }
}

.kws-int-variety__list {
  list-style: none;
  font-size: inherit;
  padding-inline-start: 0;

  li {
    display: flex;
    line-height: 1.5;
  }
  i {
    color: $color-kws-orange;
    line-height: 1;
    margin-inline-end: .5rem;
    font-size: 1.2em;

    &::before {
      font-weight: bold;
    }
  }
}
</style>

<style scoped lang="scss">
.variety-card {
  padding-bottom: rem(12px);
  display: flex;
  flex-direction: column;

  article {
    flex-grow: 1;
    padding: rem(12px);
    position: relative;

    &.variety-is-promoted h1 {
      margin-top: rem(6px);
    }
  }

  img {
    width: 100%;
  }

  .variety-promotion-text {
    margin: rem(12px) 0 0 0;
    font-weight: bold;
    color: $color-kws-orange;
  }

  h1 {
    font-size: rem(24px);
    line-height: 1.1667;
    margin: rem(12px) 0;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    line-height: 1.2;
    margin-bottom: rem(6px);
  }

  p:first-of-type {
    font-size: rem(14px);

    @include media-breakpoint-up(m) {
      font-size: rem(18px);
    }
  }

  p:last-of-type {
    font-size: inherit;
    font-weight: 700;
    margin-bottom: rem(24px);
  }

  h2 {
    margin-bottom: rem(6px);
  }

  ul {
    margin-bottom: rem(36px);
    // padding-left: rem(24px);
  }
  .link-more {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-grow: 1;

    &::before {
      width: 1.425em;
    }

    &:hover {
      border-bottom: none;
      text-decoration: underline;
    }
  }
  footer {
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    flex-direction: column;

    .variety-buttons {
      display: flex;
      flex-wrap: wrap-reverse;
      align-items: center;
      gap: 1rem;
      margin-bottom: rem(24);

      &:last-child {
        margin-bottom: 0;
      }
    }
    .variety-cta-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .button {
      flex-grow: 1;
    }
  }

  @include media-breakpoint-up(m) {
    width: 50%;

    article {
      display: flex;
      flex-direction: column;

      footer {
        flex-grow: 1;
        align-content: end;
      }
    }
  }

  @each $breakpoint in (m, l, xl) {
    @include media-breakpoint-up($breakpoint) {
      $gutter: map-get($grid-gutter-widths, $breakpoint);
      padding-inline-end: (rem($gutter) / 2);

      article {
        padding: rem($gutter / 2);
      }
    }
  }
}
</style>
